module.exports = __webpack_public_path__ + "img/banner-4.cf6f3057.png";